'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { formatNumber } from '@lichtblick/localization';
import { BoxCTA } from '@lichtblick/photon/atoms/box-cta/box-cta';
import { Headline } from '@lichtblick/photon/atoms/headline/headline';
import { Text } from '@lichtblick/photon/atoms/text/text';
import { TextCTA } from '@lichtblick/photon/atoms/text-cta/text-cta';
import { Modal } from '@lichtblick/photon/organisms/modal/modal';
import styles from './calculator-layout.module.scss';
import { usageLimitElectricity, usageLimitGas } from './constants';
export const UsageModal = ({ isOpen, route, setIsOpen })=>{
    const isElectricity = route === '/gewerbestrom';
    const energyName = isElectricity ? 'Strom' : 'Gas';
    return /*#__PURE__*/ _jsx(Modal, {
        footerContent: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(BoxCTA, {
                    as: "a",
                    className: styles['modal-box-cta'],
                    href: route,
                    variant: "primary",
                    children: "Mehr erfahren"
                }),
                /*#__PURE__*/ _jsx(TextCTA, {
                    as: "button",
                    "data-testid": "button-modal-close",
                    onClick: ()=>setIsOpen(false),
                    children: "Schließen"
                })
            ]
        }),
        isOpen: isOpen,
        onPointerDownOutside: ()=>setIsOpen(false),
        title: "Mehr erfahren",
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles['modal-content'],
            children: [
                /*#__PURE__*/ _jsxs(Headline, {
                    renderAs: "h2",
                    size: "s",
                    children: [
                        "Für dich lohnt sich Gewerbe",
                        energyName
                    ]
                }),
                /*#__PURE__*/ _jsxs(Text, {
                    renderAs: "p",
                    children: [
                        "Mit einem ",
                        energyName,
                        "verbrauch ab",
                        ' ',
                        isElectricity ? formatNumber(usageLimitElectricity.max + 1) : formatNumber(usageLimitGas.max + 1),
                        " kWh fällst du unter unsere Gewerbe",
                        energyName,
                        "-Tarife. Informiere dich jetzt ganz einfach über Gewerbe",
                        energyName,
                        " und wie du davon profitieren kannst."
                    ]
                })
            ]
        })
    });
};

//# sourceMappingURL=UsageModal.js.map